import { z } from 'zod';

export const reReframeVerticalsRequestSchema = z.object({
  collectionId: z.number().int().positive().optional(),
  cursor: z.string().optional(),
  limit: z.number().int().positive().optional(),
});

export type IReReframeVerticalsRequest = z.infer<typeof reReframeVerticalsRequestSchema>;
